import styled from "styled-components";
import {
  CommonModalDwebStyle,
  CommonModalHeader,
} from "../CommonModalDweb/CommonModalDweb.style";

export const PaymentFailedModalStyle = styled.div`
  ${CommonModalDwebStyle} {
    background: #fcdadb;
  }
  ${CommonModalHeader} {
    background: #fcdadb;
  }
`;
export const PaymentFailedNote = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 26px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
